import { Box } from "@mui/system";
import Dashboard from "../dashboard/Dashboard";
import Header from "./Header";

const Landing = () => {

  return (
    <Box  >
      <Header />
      <Box sx={{
        p: { xs: 1, md: 3 },
      }}>
        <Dashboard />
      </Box>
    </Box>
  );
};

export default Landing;
